import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Component, Inject } from '@angular/core';
import { Projeto } from '../models/projeto.model';
import { Relatorio } from '../models/relatorio.model';
import { Cabecalho } from '../models/cabecalho.model';
import { Dataset } from '../models/dataset.model';
import { Template } from '../models/template.model';
import { Tenant } from '../models/tenant.model';

@Injectable({
  providedIn: 'root',
})


export class RequestsService {
  private baseUrl: string;
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  getReportData(distinctor, idReport, params): Observable<Relatorio> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Relatorio>(this.baseUrl +`relatorio/get?idRelatorio=${idReport}${distinctor?"&distintivo="+distinctor:""}&parametros=${params}`);
  }

  getProjeto(id: number): Observable<Projeto> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Projeto>(this.baseUrl + 'projeto/get?id=' + id);
  }

  listProjetos(): Observable<Projeto[]> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Projeto[]>(this.baseUrl + 'projeto/list');
  }

  listOutrosProjetos(idProjeto): Observable<Projeto[]> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Projeto[]>(this.baseUrl + 'projeto/listoutros?idProjeto=' + idProjeto);
  }

  insertProjeto(obj: Projeto): Observable<any> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    const httpHeaders = new HttpHeaders();
    return this.http.post<Projeto>(this.baseUrl + 'projeto/insert', obj);
  }

  updateProjeto(obj: Projeto): Observable<any> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    const httpHeaders = new HttpHeaders();
    return this.http.post<Projeto>(this.baseUrl + 'projeto/update', obj);

  }

  deleteProjeto(idProjeto): Observable<Projeto> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    const httpHeaders = new HttpHeaders();
    return this.http.post<Projeto>(this.baseUrl + 'Projeto/delete?idProjeto=' + idProjeto, null);
  }

  listTenants(): Observable<Tenant[]> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Tenant[]>(this.baseUrl + 'tenant/list');
  }

  listTenantsByProjeto(idProjeto): Observable<Tenant[]> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Tenant[]>(this.baseUrl + 'tenant/listByProjeto?idProjeto='+idProjeto);
  }

  insertTenant(obj: Tenant): Observable<Tenant> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
  
    return this.http.post<Tenant>(this.baseUrl + 'tenant/insert', obj);
  }

  updateTenant(obj: Tenant): Observable<Tenant> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });

    return this.http.post<Tenant>(this.baseUrl + 'tenant/update', obj);
  }

  deleteTenant(idTenant): Observable<Tenant> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.post<Tenant>(this.baseUrl + 'tenant/delete?idTenant=' + idTenant, null);
  }

  listCabecalhos(): Observable<Cabecalho[]> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Cabecalho[]>(this.baseUrl + 'cabecalho/list');
  }

  getCabecalho(id: number): Observable<Cabecalho> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Cabecalho>(this.baseUrl + 'Cabecalho/get?id=' + id);
  }

  listCabecalhosByProjeto(idProjeto): Observable<Cabecalho[]> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Cabecalho[]>(this.baseUrl + 'cabecalho/listByProjeto?idProjeto='+idProjeto);
  }

  insertCabecalho(obj: Cabecalho): Observable<Cabecalho> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.post<Cabecalho>(this.baseUrl + 'cabecalho/insert', obj);
  }

  updateCabecalho(obj: Cabecalho): Observable<Cabecalho> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.post<Cabecalho>(this.baseUrl + 'cabecalho/update', obj);
  }

  deleteCabecalho(idCabecalho): Observable<Cabecalho> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    const httpHeaders = new HttpHeaders();
    return this.http.post<Cabecalho>(this.baseUrl + 'cabecalho/delete?idCabecalho=' + idCabecalho, null);
  }

 
  listTemplates(): Observable<Template[]> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Template[]>(this.baseUrl + 'Template/list');
  }

  
  getTemplate(id:number): Observable<Template> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Template>(this.baseUrl + 'Template/get?id='+id);
  }

  listTemplatesByProjeto(idProjeto): Observable<Template[]> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Template[]>(this.baseUrl + 'Template/listByProjeto?idProjeto='+idProjeto);
  }

  insertTemplate(obj: Template): Observable<Template> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.post<Template>(this.baseUrl + 'Template/insert', obj);
  }

  updateTemplate(obj: Template): Observable<Template> {
    return this.http.post<Template>(this.baseUrl + 'Template/update', obj);
  }

  deleteTemplate(idTemplate): Observable<Template> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    const httpHeaders = new HttpHeaders();
    return this.http.post<Template>(this.baseUrl + 'template/delete?idTemplate=' + idTemplate, null);
  }
  
 
  listDatasets(): Observable<Dataset[]> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Dataset[]>(this.baseUrl + 'Dataset/list');
  }

  listDatasetsByProjeto(idProjeto): Observable<Dataset[]> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    return this.http.get<Dataset[]>(this.baseUrl + 'Dataset/listByProjeto?idProjeto='+idProjeto);
  }

  insertDataset(obj: Dataset): Observable<Dataset> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    const httpHeaders = new HttpHeaders();
    return this.http.post<Dataset>(this.baseUrl + 'Dataset/insert', obj);
  }

  updateDataset(obj: Dataset): Observable<Dataset> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    const httpHeaders = new HttpHeaders();
    return this.http.post<Dataset>(this.baseUrl + 'Dataset/update', obj);
  }

  deleteDataset(idDataset): Observable<Dataset> {
    //let header = new HttpHeaders({ 'Authorization': 'Bearer ' + userToken });
    const httpHeaders = new HttpHeaders();
    return this.http.post<Dataset>(this.baseUrl + 'dataset/delete?idDataset=' + idDataset, null);
  }

}
